import React from "react";
import Modal from "../app/Modal";
import { connect } from "react-redux";
import * as actions from "../../actions";

import "./Subscriptions.css";
import Chip from "@material-ui/core/Chip";

class Component extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      zohoAccessToken: "",
      zohoRefreshToken: ""
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleCloseReload = this.handleCloseReload.bind(this);
    this.handleCloseCustom = this.handleCloseCustom.bind(this);
  }

  componentDidMount() {
    this.props.fetchZohoCustomers();
  }

  handleOpen() {
    this.setState({ modalOpen: true });
  }

  handleClose() {
    this.setState({ modalOpen: false });
  }

  handleCloseReload = () => {
    this.setState({ modalOpen: false });
    this.props.reloadData();
  };

  handleCloseCustom = () => {
    this.setState({ modalOpen: false });
    this.props.doCustomAction();
  };

  render() {
    return (
      <div className="component-menu pad-20">
        <div className="row">
          <div className="col s12">
            <div className="card grey darken-5">
              <div className="card-action">
                <span className="card-title">Subscriptions</span>
              </div>
              <div className="card-content white-text">
                <div className="row">
                  <div className="col s12 txt-left">STATUS UPDATE</div>
                </div>
                <div className="row">
                  <div className="col s12 txt-left">
                    <table>
                      <tbody>
                        <tr>
                          <td>Subscription</td>
                          <td>Name</td>
                          <td>Status</td>
                          <td>Amount</td>
                          <td>Created</td>
                          <td>Expires</td>
                          <td>Actions</td>
                        </tr>
                        <tr>
                          <td>90300000079200</td>
                          <td>Menus Pro</td>
                          <td>
                            <Chip label="Active" color="primary" />
                          </td>
                          <td>$50.00</td>
                          <td>9-10-19</td>
                          <td>3-30-20</td>
                          <td>
                            <button className="waves-effect waves-light btn btn-icon">
                              edit
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td>90300000079201</td>
                          <td>Menus</td>
                          <td>
                            <Chip label="Active" color="primary" />
                          </td>
                          <td>$50.00</td>
                          <td>9-10-19</td>
                          <td>3-30-20</td>
                          <td>
                            <button className="waves-effect waves-light btn btn-icon">
                              edit
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td>90300000079202</td>
                          <td>Menus Pro</td>
                          <td>
                            <Chip label="Active" color="primary" />
                          </td>
                          <td>$50.00</td>
                          <td>9-10-19</td>
                          <td>3-30-20</td>
                          <td>
                            <button className="waves-effect waves-light btn btn-icon">
                              edit
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td>90300000079203</td>
                          <td>Menus Pro</td>
                          <td>
                            <Chip label="Expired" color="secondary" />
                          </td>
                          <td>$50.00</td>
                          <td>9-10-19</td>
                          <td>3-30-20</td>
                          <td>
                            <button className="waves-effect waves-light btn btn-icon">
                              edit
                            </button>
                          </td>
                        </tr>
                        <tr>
                          <td>90300000079204</td>
                          <td>Menus Pro</td>
                          <td>
                            <Chip label="Active" color="primary" />
                          </td>
                          <td>$50.00</td>
                          <td>9-10-19</td>
                          <td>3-30-20</td>
                          <td>
                            <button className="waves-effect waves-light btn btn-icon">
                              edit
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="card-action">&nbsp;</div>
            </div>
          </div>
        </div>
        <Modal modalOpen={this.state.modalOpen}>
          <h2>Modal Content</h2>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    zohoCustomers: state.zohoCustomers
  };
}

export default connect(
  mapStateToProps,
  actions
)(Component);
